import { MdAlternateEmail } from 'react-icons/md';

export const MentionBadge = () => (
  <span className="bg-danger-40 px-1 py-0.5 rounded-full">
    <MdAlternateEmail size={9} className="shrink-0 text-white" />
  </span>
);
